import { Link } from 'react-router-dom';
import { GraduationCap, ChevronLeft } from 'lucide-react';

export default function EduEvaluatorPage() {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center p-4 text-center">
      <div className="bg-surface border-border-main max-w-md rounded-3xl border p-10 shadow-lg">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-emerald-500/10 text-emerald-500">
          <GraduationCap className="h-8 w-8" />
        </div>
        <h1 className="text-text-main mb-2 text-2xl font-black">
          Edu-Evaluator
        </h1>
        <p className="text-text-secondary mb-8">
          This application is currently under development.
        </p>
        <Link
          to="/"
          className="hover:text-primary flex items-center justify-center gap-2 text-sm font-bold text-slate-500 transition-colors"
        >
          <ChevronLeft className="h-4 w-4" />
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
